module.exports = __webpack_public_path__ + "img/214.2c5d8409.png";